if ($('.js-data-table-playlist-results').length) {
    function returnDataTablePlaylistsOptions(dataArray) {
        return {
            data: dataArray,
            order: [],
            columns: [
                {
                    data: 'Image',
                    render: function (data, type, row, meta) {
                        const layout = `
                            <img src="${data}" alt="" class="cardImageCell__img">
                            ${
                                !isCreatePlaylist && !isEditPlaylist
                                    ? `<span class="cardImageCell__favorite ${
                                          row.Favorite === 'true'
                                              ? 'favorite'
                                              : ''
                                      }"></span>`
                                    : isCreatePlaylist && !isEditPlaylist
                                    ? `<div class="pos-absolute t-0 r-0 w-40 h-40 bg-c-white-06 df fcc cursor-pointer js-event-stop-propagation">
                                            ${
                                                isCreatePlaylist &&
                                                row.isInPlaylist
                                                    ? `<div class="c-dark">
                                            <svg class="icon w-24 h-24">
                                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#icon-playlist-24"></use>
                                            </svg>
                                            </div>`
                                                    : `<div class="c-dark">
                                                <input class="js-playlist-card-checkbox" type="checkbox" name="${row.TOD.toString()}" id="${row.TOD.toString()}" />
                                                <label for="${row.TOD.toString()}" class="cardCheckbox"/>    
                                        </div>`
                                            }
                                        </div>`
                                    : !isCreatePlaylist &&
                                      isEditPlaylist &&
                                      `<button type="button" class="cursor-pointer playlistCellDeleteBtn c-dark c-orange-hover js-event-stop-propagation js-delete-video-from-playlist-btn" data-video-id="${row.id}">
                                                <svg class="icon w-24 h-24">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#icon-cart-24"></use>
                                                </svg>
                                            </button>`
                            }
                            `;
                        return layout;
                    },
                },
                {
                    data: 'Course',
                    render: function (data, type, row, meta) {
                        if (type === 'display') {
                            return `<div class="df fbc gap-8 fw">
                                        <span>${row.Course}</span>
                                        ${
                                            !isCreatePlaylist &&
                                            row.isInPlaylist
                                                ? `<div class="c-orange">
                                                <svg class="icon w-16 h-16">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#icon-playlist-24"></use>
                                                </svg>
                                            </div>`
                                                : ''
                                        }
                                    </div>`;
                        }
                        return data;
                    },
                },
                {
                    data: 'TOD',
                    type: 'range',
                },
                {
                    data: 'Date',
                    type: 'date',
                    render: function (data) {
                        let formattedDate = moment(data).format('ll');
                        return formattedDate;
                    },
                },
                {
                    data: 'Name',
                    render: function (data, type, row, meta) {
                        if (type === 'display' && row.Name === '') {
                            return `<span>-</span>`;
                        }
                        return data;
                    },
                },
                {
                    data: 'BIB',
                    render: function (data, type, row, meta) {
                        if (type === 'display' && row.BIB === '') {
                            return `<span>-</span>`;
                        }
                        return data;
                    },
                },

                { data: 'Time' },
                { data: 'Link' },
                { data: 'Favorite' },
                { data: 'Class' },
                { data: 'Gender' },
            ],
            columnDefs: [
                {
                    targets: 2,
                    visible: true,
                    searchable: true,
                },
                {
                    target: 7,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 8,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 9,
                    visible: false,
                    searchable: true,
                },
                {
                    target: 10,
                    visible: false,
                    searchable: true,
                },
            ],
            scrollX: true,
            fixedColumns: {
                leftColumns: 1,
            },
            search: {
                caseInsensitive: true,
            },
            // bDestroy - enable rerender table with new data array by event.
            bDestroy: true,
            pageLength: 15,
            layout: {
                top2Start: {
                    rowClass: 'dt-filters-row',
                    className: 'dt-filters-cell',
                    features: function () {
                        let toolbar = `<div class="dt-filters-container">
                            <div class='dc js-dt-filters-container'></div>
                            <div class="btn-reset-all-desktop-wrapper hidden-flex js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>
                        `;
                        return toolbar;
                    },
                },
                top1Start: {
                    rowClass: 'dt-filters-row-mobile',
                    className: 'dt-filters-cell-mobile',
                    features: function () {
                        let layout = `<div class="df fsc gap-16">
                            <button class='btn-filter' type='button' data-open='mdl-filters'>
                                <span>Filters</span>
                            </button>
                            <div class="hidden-block js-dt-reset-all-cell">
                                <button type='button' class='btn-reset-all fz-12-16 fw-600 bg-c-transparent c-gray-6 c-dark-hover js-reset-all-btn'>
                                    <span>Reset all</span>
                                </button>
                            </div>
                        </div>`;

                        return layout;
                    },
                },
                topStart: {
                    info: {
                        text: 'VIDEOS: _TOTAL_',
                        empty: 'VIDEOS: _TOTAL_',
                        search: '',
                    },
                },
                topEnd: {
                    rowClass: 'dt-results-row',
                    className: 'dt-sort-by-cell-training',
                    features: function () {
                        const sortByData = ['Date', 'Time'];

                        const layout = `<div class="table-sort-mobile js-table-sort-mobile-container">
                            <button type="button" class="table-sort-mobile__button c-gray js-sort-by-button" data-drop="sort-by-dropdown">
                                <span class="df">
                                    Sort by<span class="hidden-flex gap-8 js-sort-by-container">:<span class="fw-400 js-sort-by-text"></span></span>
                                </span>
                            </button>
                            <div id="sort-by-dropdown" class="table-sort-mobile__dropdown dropdown under left js-sort-by-dropdown js-dropdown">
                            ${sortByData
                                .map(
                                    (item) => `
                                    <button class="table-sort-mobile__option js-sort-by-mobile js-sort-by-mobile-${item.toLowerCase()}" type="button">
                                        <span class="js-sort-by-value">${item}</span>
                                        <span class="table-sort-mobile__order"></span>
                                    </button>
                                `
                                )
                                .join('')}
                            </div>
                        </div>`;
                        return layout;
                    },
                },
                bottomStart: null,
                bottomEnd: {
                    rowClass: 'dt-paging-row',
                    className: 'dt-paging-cell',
                    features: {
                        paging: {
                            type: 'simple_numbers',
                            buttons: 6,
                        },
                    },
                },
            },
            createdRow: function (row, data, dataIndex) {
                $(row).each(function (index) {
                    $(this)
                        .attr('data-href', data.Link)
                        .addClass('js-dt-row-clickable');
                });
            },
            initComplete: function () {
                // Add custom class to search input
                $('.dt-search').addClass(
                    'form-item-wrap form-item-wrap--search'
                );

                const filtersContainer = $('.js-dt-filters-container');
                filtersContainer.empty();

                this.api()
                    .columns([2, 10, 9, 1])
                    .every(function (colIdx) {
                        let title = this.column(colIdx).title();
                        let column = this;

                        if (colIdx == 2) {
                            const timeValues = dataArray.map((item) =>
                                formatStringToMinutes(item.TOD)
                            );
                            const minTime = Math.min(...timeValues);
                            const maxTime = Math.max(...timeValues);
                            const maxTimeToDisplay =
                                maxTime + 60 > 1440 ? 1440 : maxTime + 60;

                            $(`<div class="form-item-wrap form-item-wrap--table-filter form-item-wrap--table-filter--range js-select-filter-wrap order${colIdx}">
                            <button type='button' class='btn-dropdown js-tod-filter-result-btn' data-drop-filter='tod-dropdown-range-filter'>
                                <span>TOD:</span>
                                <span class='js-tod-filter-result-text'>All</span>
                            </button>
                        </div>`).appendTo(filtersContainer);

                            $(`<div id='tod-dropdown-range-filter' class="dropdown dropdown--training-filter under right js-dropdown-filter">
                            <div class='df fse gap-12'>
                                <div class='df fdc gap-8 flex-1-0-0'>
                                    <div class='fz-15-26 c-gray-5'>From</div>
                                    <div class="form-item-wrap w-154">
                                        <input class='form-item unusable js-tod-min-field' type="text" readonly value='${formatTime(
                                            minTime
                                        )}'>
                                    </div>
                                </div>
                                <div class='mb-23 h-2 w-12 bg-c-gray-5 flex-shrink-0'></div>
                                <div class='df fdc gap-8 flex-1-0-0'>
                                    <div class='fz-15-26 c-gray-5'>To</div>
                                    <div class="form-item-wrap w-154">
                                        <input class='form-item unusable js-tod-max-field' type="text" readonly value='${formatTime(
                                            maxTimeToDisplay
                                        )}'>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-23 pb-23">
                                <div class='js-tod-range-slider range-ui-slider'></div>
                            </div>
                        </div>`).appendTo(
                                $(`.js-select-filter-wrap.order${colIdx}`)
                            );

                            $('.js-tod-range-slider').slider({
                                range: true,
                                min: minTime,
                                max: maxTimeToDisplay,
                                values: [minTime, maxTimeToDisplay],
                                step: 1,
                                slide: function (event, ui) {
                                    updateTimeRangeFieldsVisualFormat(
                                        ui.values[0],
                                        ui.values[1]
                                    );
                                    tableTrainingResults.draw();
                                    isSliderAtEdge();
                                },
                                change: function (event, ui) {
                                    updateTimeRangeFieldsVisualFormat(
                                        ui.values[0],
                                        ui.values[1]
                                    );
                                    tableTrainingResults.draw();
                                },
                            });
                        } else {
                            $(
                                `<div class="form-item-wrap form-item-wrap--no-border form-item-wrap--table-filter js-select-filter-wrap order${colIdx}"></div>`
                            ).appendTo(filtersContainer);
                            let selectBase = $(
                                `<select id="${colIdx}" class="js-select2-datatable" multiple data-placeholder="${title}: All"></select>`
                            )
                                .appendTo(
                                    $(`.js-select-filter-wrap.order${colIdx}`)
                                )
                                .on('change', function () {
                                    //Get the "text" property from each selected data
                                    //regex escape the value and store in array
                                    var data = $.map(
                                        $(this).select2('data'),
                                        function (value, key) {
                                            return value.text
                                                ? '^' +
                                                      $.fn.dataTable.util.escapeRegex(
                                                          value.text
                                                      ) +
                                                      '$'
                                                : null;
                                        }
                                    );

                                    //if no data selected use ""
                                    if (data.length === 0) {
                                        data = [''];
                                    }

                                    //join array into string with regex or (|)
                                    var val = data.join('|');

                                    //search for the option(s) selected
                                    column
                                        .search(val ? val : '', true, false)
                                        .draw();
                                });

                            let uniqueOptions = 0;

                            column
                                .data()
                                .unique()
                                .sort()
                                .each(function (d, j) {
                                    uniqueOptions += 1;
                                    const layout =
                                        '<option value="' +
                                        d +
                                        '">' +
                                        d +
                                        '</option>';
                                    if (colIdx == 7) {
                                        selectBase.prepend(layout);
                                    } else {
                                        selectBase.append(layout);
                                    }
                                });

                            $.fn.select2.amd.require(
                                [
                                    'select2/utils',
                                    'select2/dropdown',
                                    'select2/dropdown/attachContainer',
                                    'select2/dropdown/search',
                                    'select2/dropdown/attachBody',
                                ],
                                function (
                                    Utils,
                                    Dropdown,
                                    DropdownSearch,
                                    AttachBody,
                                    DropdownAdapter,
                                    AttachContainer
                                ) {
                                    let $select = $(
                                        '.js-select2-datatable'
                                    ).select2({
                                        closeOnSelect: false,
                                        width: '100%',
                                        minimumResultsForSearch: 5,
                                        dropdownAdapter: Utils.Decorate(
                                            Utils.Decorate(
                                                Dropdown,
                                                DropdownSearch
                                            ),
                                            AttachBody
                                        ),
                                    });

                                    $select.on('change', function (e) {
                                        var $selection = $(this)
                                            .closest('.js-select-filter-wrap')
                                            .find(
                                                '.select2-selection__rendered'
                                            );
                                        var count = $(this).val().length;
                                        var columnTitle = $($(this)[0])
                                            .attr('data-placeholder')
                                            .split(':')[0];

                                        if (count > 1) {
                                            $selection.html(
                                                `<span class="selected-options">${columnTitle}: (${count})</span>`
                                            );
                                        } else if (count === 1) {
                                            $selection.html(
                                                `<span class="selected-option">${columnTitle}: ${
                                                    $(this).val()[0]
                                                }</span>`
                                            );
                                        } else {
                                            $selection.html(``);
                                        }

                                        setSelect2PlaceholderWidth();
                                    });

                                    setSelect2PlaceholderWidth();
                                }
                            );

                            if (uniqueOptions < 12) {
                                selectBase
                                    .closest('.form-item-wrap')
                                    .addClass('hide-search');
                            }
                        }
                    });

                displayLargeDataTooltip();
                addCellLabel();
                setInfoResultsIntoMobileContainer(
                    this.api().page.info().recordsDisplay
                );
                setResetAllControlsState();
                playlistControls();
            },
        };
    }

    let tablePlaylists = $('.js-data-table-playlist-results').DataTable(
        returnDataTablePlaylistsOptions(playlistSearchResultsDataArray)
    );

    initTrainingResultsFunctionSet(tablePlaylists);
}
